export const LOGGED_IN = 'LOGGED_IN';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGGED_OUT = 'LOGGED_OUT';
